import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4218077008/src/fl-city-jobs-frontend/src/app/(admin)/DashboardClient.tsx");
